require.config({
    paths: {
//RequireJS plugins
       'domReady'     : 'vendor/domReady',

//JQuery
       'jQuery'            : 'vendor/jquery-3.7.0',
       'jQueryUi'          : 'vendor/jquery-ui-1.13.2',

//JQuery plugins
      'jQueryCookie'         : 'plugins/jquery.enhanced.cookie',
      'jQueryHighlight'      : 'plugins/jquery.myhighlight-3',
      'dgrhMdLink'           : 'plugins/dgrh-mdLink',
      'dgrhEraser'           : 'plugins/dgrh-eraser',
      'dgrhAutocomplete'     : 'plugins/dgrh-autocomplete',
      'jQueryMultiSel'       : 'plugins/jquery.multiselect',
      'jQueryMultiSelFlt'    : 'plugins/jquery.multiselect.filter',
      'mskInput'             : 'plugins/jquery.maskedinput',

//Mustache
      'Mustache'     : 'vendor/mustache',

//CANDELEC main application
      'DGRH'          : 'DGRH/DGRH',

//CANDELEC Util
        'RuleBuilder'                  : 'DGRH/Models/AutoComplete/Highlight/Rule/RuleBuilder',
        'RuleFactory'                  : 'DGRH/Models/AutoComplete/Highlight/Rule/RuleFactory',
        'Highlighter'                  : 'DGRH/Models/AutoComplete/Highlight/Highlighter',
        'Formatter'                    : 'DGRH/Models/AutoComplete/ItemFormatters/Formatter',
//        'LibelleTplDatas'              : 'DGRH/Models/AutoComplete/Templates/Datas/Libelle',
        'CodeLibelleTplDatas'          : 'DGRH/Models/AutoComplete/Templates/Datas/CodeLibelle',
        'NomPrenomDateTplDatas'        : 'DGRH/Models/AutoComplete/Templates/Datas/NomPrenomDate',
        'NomPrenomUidCourrielTplDatas' : 'DGRH/Models/AutoComplete/Templates/Datas/NomPrenomUidCourriel',
//        'EtablissementTplDatas'        : 'DGRH/Models/AutoComplete/Templates/Datas/Etablissement',
        'Factory'                      : 'DGRH/Models/Util/Factory',
        'Proxy'                        : 'DGRH/Models/Util/Proxy',
        'DateTime'                     : 'DGRH/Models/Util/DateTime',
        'SearchIcon'                   : 'DGRH/Models/Util/SearchIcon',
        'QueryString'                  : 'DGRH/Models/Util/QueryString',
        'DataFetcher'                  : 'DGRH/Models/Util/DataFetcher',
        'SendState'                    : 'DGRH/Models/Util/SendState',
        'SubmitOnChange'               : 'DGRH/Models/Util/SubmitOnChange',
//        'SearchResponsable'            : 'DGRH/Models/Util/SearchResponsable',
        'MessageAjax'                  : 'DGRH/Models/Util/MessageAjax',
//        'Tooltip'                      : 'DGRH/Models/Util/Tooltip',
        'TypedCharacter'               : 'DGRH/Models/Util/TypedCharacter',

//CANDELEC MdlWndBase
        'MdlWndBase'        : 'DGRH/Models/ModalWnd/Base',

//CANDELEC SearchFilters ObservationEffectifList
        'SearchFilterBase'           : 'DGRH/Models/Forms/SearchFilters/Base',
        'SearchFilterCndCndList'     : 'DGRH/Modules/Candidature/Forms/SearchFilters/CandidatureCndList',
        'SearchFilterObeList'        : 'DGRH/Modules/ObservationEffectif/Forms/SearchFilters/ObservationEffectifList',
        'SearchFilterCptUsrList'     : 'DGRH/Modules/Admin/Forms/SearchFilters/CompteUtilisateurList',

//CANDELEC Handler
        'App_ErrorHandler'                 : 'DGRH/Modules/App/Handler/Error',
        'App_SigninHandler'                : 'DGRH/Modules/App/Handler/Signin',
        'App_PasswordDefineHandler'        : 'DGRH/Modules/App/Handler/PasswordDefine',
        'Obe_ObservationEffectifHandler'   : 'DGRH/Modules/ObservationEffectif/Handler/ObservationEffectifList',
        'Cnd_CandidatListHandler'          : 'DGRH/Modules/Candidature/Handler/CandidatureCndList',
        'Cnd_CandidatListExportHandler'    : 'DGRH/Modules/Candidature/Handler/CandidatureCndListExport',
        'Cnd_CandidatHandler'              : 'DGRH/Modules/Candidature/Handler/CandidatCrud',
        'Cnd_GestionDepotHandler'          : 'DGRH/Modules/Candidature/Handler/GestionDepot',
        'Cnd_DepotMaterielDeVote'          : 'DGRH/Modules/Candidature/Handler/DepotMaterielDeVote',
        'Cnd_StatutMaterielDeVote'         : 'DGRH/Modules/Candidature/Handler/StatutMaterielDeVote',
        'Adm_CompteUtilisateurHandler'     : 'DGRH/Modules/Admin/Handler/CompteUtilisateurList',
        'Adm_CompteUtilisateurCrudHandler' : 'DGRH/Modules/Admin/Handler/CompteUtilisateurCrud',
        'Ost_OsticHandler'                 : 'DGRH/Modules/Ostic/Handler/OsticCrud',

    },
    shim: {
        'jQuery': {
            exports: '$'
        },
        'jQueryUi': {
            deps: ['jQuery']
        },
        'jQueryCookie': {
            deps: ['jQuery']
        },
        'jQueryHighlight': {
            deps: ['jQuery', 'jQueryUi']
        },
        'jQueryMultiSel': {
            deps: ['jQuery', 'jQueryUi']
        },
        'jQueryMultiSelFlt': {
            deps: ['jQuery', 'jQueryUi', 'jQueryMultiSel']
        },
        'jQueryPlaceholder': {
            deps: ['jQuery', 'jQueryUi']
        }
    }
});

//Main libs - Libraries and modules that will be needed on all pages of the site
requirejs(['domReady', 'jQuery'], function() {

});
define("main", function(){});

